import { render, staticRenderFns } from "./CreateAlert.vue?vue&type=template&id=5f7dd801&scoped=true"
import script from "./CreateAlert.vue?vue&type=script&lang=js"
export * from "./CreateAlert.vue?vue&type=script&lang=js"
import style0 from "./CreateAlert.vue?vue&type=style&index=0&id=5f7dd801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7dd801",
  null
  
)

export default component.exports